import {useGlobalContext} from "../../contexts/ContextProvider";
import PriceListPageOld from "./PriceListPage.old";
import PriceListPageRepo2 from "./PriceListPage.repo2";

export default function (params) {
    const { isRepo2 } = useGlobalContext();
    if (isRepo2) {
        return < PriceListPageRepo2 {...params} />
    }
    return <PriceListPageOld {...params} />
}